import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import HomeComponent from '../components/HomeComponent.vue';
import { useAuthStore } from '../store/authStore';

const routes: Array<RouteRecordRaw> = [
    {
      path: '/',
      name: 'HomeComponent',
      component: HomeComponent,
    },
    {
        path: '/topdeals',
        name: 'HomeComponent',
        component: HomeComponent,
      },
    {
        path: '/logout',
        name: 'HomeComponent',
        component: HomeComponent,
      }

  ];
  
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });
  
  // Global Navigation Guard to check login status
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();
    console.log('[auth][router] before check', {
      path: to.path,
      isLoggedIn: authStore.isLoggedIn,
      userEmail: authStore.userEmail,
    });
    // Check if login status is already determined
    if (!authStore.isLoggedIn) {
      await authStore.checkLoginStatus();
      console.log('[auth][router] after checkLoginStatus', {
        path: to.path,
        isLoggedIn: authStore.isLoggedIn,
        userEmail: authStore.userEmail,
      });
    }
  
    if (!authStore.isLoggedIn) {
      const result = await authStore.login();
      console.log('[auth][router] login attempt result', {
        path: to.path,
        result,
        isLoggedIn: authStore.isLoggedIn,
        userEmail: authStore.userEmail,
      });
      if (result === 'redirect') {
        return;
      }
      if (!authStore.isLoggedIn) {
        console.warn('[auth][router] blocking navigation: still not logged in');
        return next(false);
      }
    }
    next();
  });
  
  export default router;